/**
 * TtfLongHorMetric.ts class for EJ2-PDF
 */
var TtfLongHorMetric = /** @class */ (function () {
    function TtfLongHorMetric() {
    }
    return TtfLongHorMetric;
}());
export { TtfLongHorMetric };
